module.exports = __webpack_public_path__ + "img/chevron-right-alt.fe40cd40.svg";